import { BnsnLogoColorHorizontal } from '~/bnsn/ui'
import { Link } from '@remix-run/react'

type LogoLinkProps = {
  href?: string
}

/**
 * LogoLink is a link to the home page with the BNSN logo.
 *

 *
 * @param {LogoLinkProps} props
 */
export const LogoLink = ({ href }: LogoLinkProps) => {
  return (
    <Link to={href ?? '/'} title="BNSN Application - Home Page">
      <BnsnLogoColorHorizontal />
    </Link>
  )
}
